import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { CLEVER_TAP_EVENT } from 'src/app/core/constants/clever-tab-event-constants';
import { appErrorEventObj } from '../utils/clever-tab-functions';
import { AnalyticsService } from './analytics.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	constructor(private analyticsService: AnalyticsService) {
		console.log('global error handler loaded');
	}
	handleError(error) {
		const message = error.message ? error.message : error.toString();
		console.log(message);
		console.log(error);
		if (typeof error.rejection === 'object') {
			const errorObj = JSON.parse(JSON.stringify(error.rejection))
			delete errorObj.headers
			let urlPayloadObj = {}
			const eventReqObjData = [
				'orderId',
				'sectionId',
				'promoId',
				'itemId',
				'couponId',
				'outletId',
				'outletName'
			]
			if (window.location.search) {
				const queryObj = JSON.parse('{"' + decodeURI(window.location.href.split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
				eventReqObjData.forEach((key) => {
					if (queryObj.hasOwnProperty(key)) {
						urlPayloadObj[key] = queryObj[key]
					}
				})
				console.log(urlPayloadObj)
			}
			if (errorObj.status === 500 ) {
				this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.APP_ERROR, appErrorEventObj(urlPayloadObj, errorObj));
			}
		}

	}


}

